import React from 'react';
import {Bar} from 'react-chartjs-2';
import ChartTable from '../ChartTable';
import accounting from 'javascripts/vendor/accounting';

const BarChart = (props) => {
  const {
    labels,
    datasets,
    colors,
    swapRowsColumns,
    horizontalColors,
    horizontalTotal,
    verticalColors,
    verticalTotal,
    useCurrency,
    units
  } = props;

  const data = {
    labels: labels,
    datasets: datasets.map((dataset, index) => {
      return (
        {
          label: dataset.label,
          backgroundColor: colors[index],
          hoverBackgroundColor: colors[index],
          borderColor: 'black',
          borderWidth: 1,
          data: dataset.values
        }
      )
    })
  }

  return(
    <div className="chart_grid">
      <div className="full_width">
        <Bar
          data={data}
          height={300}
          options={{
            maintainAspectRatio: true,
            tooltips: {
              callbacks: {
                label: (tooltipItem, data) => {
                  const label = data.datasets[tooltipItem.datasetIndex].label || '';
                  const value = useCurrency ?
                    accounting.formatMoney(tooltipItem.value, '$', 2) : tooltipItem.value;
                  return `${label} - ${value} ${units || ''}`;
                }
              }
            },
            legend: {
              display: false
            },
            scales: {
              xAxes: [{
                stacked: true,
                maxBarThickness: 50,
              }],
              yAxes: [{
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  min: 0
                }
              }]
          }}
        }
        />
      </div>
      <div>
        <ChartTable
          {...{
            labels,
            datasets,
            colors,
            swapRowsColumns,
            horizontalColors,
            horizontalTotal,
            verticalColors,
            verticalTotal,
            useCurrency
          }}
        />
      </div>
    </div>
  )
};

export default BarChart;
